import React from 'react';
import { XIcon } from 'lucide-react';
import { Toggle } from '../common/Toggle';
export const StrategyForm = ({
  strategy,
  onClose
}) => {
  return <div className="bg-white rounded-lg" data-id="element-133">
      <div className="flex justify-between items-center p-6 border-b" data-id="element-134">
        <h2 className="text-xl font-semibold" data-id="element-135">
          {strategy ? 'Editar Estrategia' : 'Nueva Estrategia'}
        </h2>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-136">
          <XIcon className="h-6 w-6" data-id="element-137" />
        </button>
      </div>
      <form className="p-6 space-y-8" data-id="element-138">
        {/* Datos Generales */}
        <section data-id="element-139">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-140">
            Datos Generales
          </h3>
          <div className="grid grid-cols-1 gap-6" data-id="element-141">
            <div data-id="element-142">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-143">
                Nombre de la Estrategia
              </label>
              <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ej: Campaña Verano 2024" data-id="element-144" />
            </div>
            <div data-id="element-145">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-146">
                Descripción
              </label>
              <textarea rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Describe los objetivos y alcance de la estrategia" data-id="element-147" />
            </div>
          </div>
        </section>
        {/* Tipo y Estado */}
        <section data-id="element-148">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-149">
            Tipo y Estado
          </h3>
          <div className="grid grid-cols-2 gap-6" data-id="element-150">
            <div data-id="element-151">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-152">
                Tipo de Estrategia
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-153">
                <option value="" data-id="element-154">Seleccionar tipo</option>
                <option value="financing" data-id="element-155">Plan de Financiación</option>
                <option value="discount" data-id="element-156">Descuento Comercial</option>
                <option value="promotion" data-id="element-157">Promoción Especial</option>
              </select>
            </div>
            <div data-id="element-158">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-159">
                Estado
              </label>
              <Toggle data-id="element-160" />
            </div>
          </div>
        </section>
        {/* Parámetros */}
        <section data-id="element-161">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-162">
            Parámetros Específicos
          </h3>
          <div className="grid grid-cols-2 gap-6" data-id="element-163">
            <div data-id="element-164">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-165">
                Tasa de Interés (%)
              </label>
              <input type="number" step="0.01" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ej: 5.99" data-id="element-166" />
            </div>
            <div data-id="element-167">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-168">
                Descuento Máximo (%)
              </label>
              <input type="number" step="0.01" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ej: 15" data-id="element-169" />
            </div>
            <div data-id="element-170">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-171">
                Plazo Mínimo (meses)
              </label>
              <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ej: 6" data-id="element-172" />
            </div>
            <div data-id="element-173">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-174">
                Plazo Máximo (meses)
              </label>
              <input type="number" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ej: 48" data-id="element-175" />
            </div>
          </div>
        </section>
        {/* Botones */}
        <div className="flex justify-end gap-4 pt-6 border-t" data-id="element-176">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-177">
            Cancelar
          </button>
          <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-178">
            Guardar
          </button>
        </div>
      </form>
    </div>;
};